import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { AutocompleteService } from './autocomplete.service';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  myControl = new FormControl();
  valueSelected: any;
  filteredOptions: any;
  inputValue: string = '';

  @Input() listenKeyup: any;

  constructor(private autocompleteService: AutocompleteService) {
    this.autocompleteService
      .selectdataListSubscription()
      .subscribe((dataList) => {
        if (this.field?.select) {
          this.field.select.options = dataList;
          this.updateList();
        }
      });
  }

  ngOnInit(): void {
    this.filteredOptions = [];
    if (this.field?.select) {
      this.filteredOptions = this.field.select.options;
    }
    this.inputValue = '';
  }

  filter(key: any) {
    this.filteredOptions = [];
    if (this.field?.select) {
      for (const elem of this.field.select.options) {
        this.filteredOptions.push(elem);
      }
    }
  }

  selected(fieldName: any, option: any) {
    this.valueSelected = option;
    this.autocompleteService.onSelectionChange({ fieldName, option });
  }

  keyup(fieldName: any, value: any, options: any) {
    this.autocompleteService.onKeyUp({ fieldName, value, options });
  }

  updateList() {
    this.filteredOptions = [];
    if (this.field?.select) {
      for (const elem of this.field.select.options) {
        this.filteredOptions.push(elem);
      }
    }
  }

  onInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.filter(value);
  }

  onKeyup(fieldName: string, event: Event, options: any[]): void {
    const value = (event.currentTarget as HTMLInputElement).value;
    this.keyup(fieldName, value, options);
  }
}

